import { EmptyState, Props as EmptyStateProps } from './EmptyState';
import { EMPTY_STATE_VARIANTS } from './EmptyState.types';

type Props = Omit<EmptyStateProps, 'variant'>;

export const EmptyStateWithContainer = (props: Props) => (
  <EmptyState variant={EMPTY_STATE_VARIANTS.WITH_BORDERED_CONTAINER} {...props} />
);

export { EmptyState };
